
<v-menu
    open-on-hover
    bottom
    offset-y
>
    <template v-slot:activator="{ on, attrs }">
        <a
            v-bind="attrs"
            v-on="on"
        >
            <c-tag
                :label     = "label"
                :active    = "active"
                :highlight = "highlight"
                class      = "mr-1"
            />
        </a>
    </template>

    <div class="pa-3 white">
        <company-card
            class="card-tooltip"
            :company = "company"
        />
    </div>
</v-menu>
